import { saveConversationsOptionQuick } from '../actions/saveConversationsOption';
import { IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import ConversationSortOrder from 'owa-service/lib/contract/ConversationSortOrder';
import { OptionQuickCustomRenderComponentProps } from 'owa-options-core';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

export interface ConversationsQuickProps extends OptionQuickCustomRenderComponentProps {
    userOptions?: UserOptionsType;
}

const CONVERSATION_VIEW_OFF_KEY = 'Off';

@reactive({
    userOptions: () => getUserConfiguration().UserOptions,
})
export default class ConversationsQuick extends React.Component<ConversationsQuickProps, {}> {
    render() {
        let { userOptions } = this.props;
        let selectedKey =
            userOptions.GlobalListViewTypeReact === ReactListViewType.Message
                ? CONVERSATION_VIEW_OFF_KEY
                : userOptions.ConversationSortOrderReact;

        return (
            <ChoiceGroup
                aria-labelledby={this.props.headerAriaId}
                selectedKey={selectedKey}
                options={[
                    {
                        key: 'ChronologicalNewestOnTop',
                        text: strings.options_conversations_quick_sortOrderTop,
                    },
                    {
                        key: 'ChronologicalNewestOnBottom',
                        text: strings.options_conversations_quick_sortOrderBottom,
                    },
                    {
                        key: CONVERSATION_VIEW_OFF_KEY,
                        text: strings.options_conversations_quick_messageView,
                    },
                ]}
                onChange={this.onChange}
            />
        );
    }

    private onChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        if (option.key === CONVERSATION_VIEW_OFF_KEY) {
            saveConversationsOptionQuick(false);
        } else {
            saveConversationsOptionQuick(true, option.key as ConversationSortOrder);
        }
    };
}
